// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../node_modules/react-loading-skeleton/dist/skeleton.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Roboto";

  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  background-color: #f2f2f2 !important;
  overflow-x: hidden;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas,  "Roboto",
    monospace;
}



.eyebutton1{
  position: absolute;
  right: 280px;
  top: 65%;
  transform: translateY(-50%);
  cursor: pointer;
}

.eyebutton2{
  position: absolute;
  right: 280px;
  top: 73%;                  
  transform: translateY(-50%);
  cursor: pointer;
}
.eyebutton3{
  position: absolute;
  right: 280px;
  top: 69%;

  transform: translateY(-50%);
  cursor: pointer;
}
.eyebutton4{

position: absolute;
right: 280px;
top: 76%;                 
transform: translateY(-50%);
cursor: pointer;
}

@media (max-width: 1000px) {
 
.eyebutton1{
  position: absolute;
  right: 60px;
  top: 65%;
  transform: translateY(-50%);
  cursor: pointer;
}

.eyebutton2{
  position: absolute;
  right: 60px;
  top: 73%;                  
  transform: translateY(-50%);
  cursor: pointer;
}
.eyebutton3{
  position: absolute;
  right: 60px;
  top: 68%;

  transform: translateY(-50%);
  cursor: pointer;
}
.eyebutton4{

position: absolute;
right: 60px;
top: 76%;                 
transform: translateY(-50%);
cursor: pointer;
}

}

`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,wDAAwD;;EAExD,mCAAmC;EACnC,kCAAkC;;EAElC,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE;aACW;AACb;;;;AAIA;EACE,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,2BAA2B;EAC3B,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,QAAQ;;EAER,2BAA2B;EAC3B,eAAe;AACjB;AACA;;AAEA,kBAAkB;AAClB,YAAY;AACZ,QAAQ;AACR,2BAA2B;AAC3B,eAAe;AACf;;AAEA;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;;EAER,2BAA2B;EAC3B,eAAe;AACjB;AACA;;AAEA,kBAAkB;AAClB,WAAW;AACX,QAAQ;AACR,2BAA2B;AAC3B,eAAe;AACf;;AAEA","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Roboto\";\n\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n\n  background-color: #f2f2f2 !important;\n  overflow-x: hidden;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas,  \"Roboto\",\n    monospace;\n}\n\n\n\n.eyebutton1{\n  position: absolute;\n  right: 280px;\n  top: 65%;\n  transform: translateY(-50%);\n  cursor: pointer;\n}\n\n.eyebutton2{\n  position: absolute;\n  right: 280px;\n  top: 73%;                  \n  transform: translateY(-50%);\n  cursor: pointer;\n}\n.eyebutton3{\n  position: absolute;\n  right: 280px;\n  top: 69%;\n\n  transform: translateY(-50%);\n  cursor: pointer;\n}\n.eyebutton4{\n\nposition: absolute;\nright: 280px;\ntop: 76%;                 \ntransform: translateY(-50%);\ncursor: pointer;\n}\n\n@media (max-width: 1000px) {\n \n.eyebutton1{\n  position: absolute;\n  right: 60px;\n  top: 65%;\n  transform: translateY(-50%);\n  cursor: pointer;\n}\n\n.eyebutton2{\n  position: absolute;\n  right: 60px;\n  top: 73%;                  \n  transform: translateY(-50%);\n  cursor: pointer;\n}\n.eyebutton3{\n  position: absolute;\n  right: 60px;\n  top: 68%;\n\n  transform: translateY(-50%);\n  cursor: pointer;\n}\n.eyebutton4{\n\nposition: absolute;\nright: 60px;\ntop: 76%;                 \ntransform: translateY(-50%);\ncursor: pointer;\n}\n\n}\n\n\n\n@import \"react-loading-skeleton/dist/skeleton.css\";\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
